import $ from "jquery";

const saisonaleCocktails = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      main: ".js-saisonale-cocktails__item",
    };
    if ($(el.main).length === 0) return;

    $(document).ready(function () {
      $(".js-saisonale-cocktails__item").on("mouseenter", function () {
        const $img = $(this).find("img");

        $img.css({
          transition: "all .3s ease-in-out",
          transform: "scale(1.1)",
        });

        setTimeout(() => {
          $img.css({
            transition: "all 1s ease-in-out",
            transform: "scale(1)",
          });
        }, 800);
      });
    });
  };
  init();
};

try {
  saisonaleCocktails();
} catch (error) {
  console.error("saisonaleCocktails", error);
}
